import { createContext } from 'react';
import { Coursedetails } from '@/models';

export const ActiveCourseContext = createContext<{
  course: Coursedetails | null;
  setCourse: any;
}>({ course: null, setCourse: () => {} }); //using any for user as it's server defined
